import { Box } from "@mui/material";
import type { ReactNode } from "react";
import { usePageLayout } from "@/app/routes/pageLayout";

type PageContainerProps = {
  children: ReactNode;
};

export function PageContainer({ children }: PageContainerProps) {
  const { paddingLeftPx, paddingRightPx, paddingYPx } = usePageLayout();

  return (
    <Box
      sx={{
        width: "100%",
        flex: 1,
        minWidth: 0,
        pl: `${paddingLeftPx}px`,
        pr: `${paddingRightPx}px`,
        py: `${paddingYPx}px`,
        minHeight: "100%",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
      }}
    >
      {children}
    </Box>
  );
}
